/**
 * Self-letter (warm-letter onboarding page) endpoint.
 *
 * Wraps `POST /self-letter/generate` on the typed `http.*` client so the
 * onboarding chip flow inherits auth-refresh + 401 retry instead of a raw
 * `fetch()` (#3268). The route is root-mounted; the gateway reads the
 * workspace from the `x-workspace-id` header `http.*` always sends, so the
 * destination is byte-identical to the raw call site this replaces.
 *
 * Hand-typed shapes: `xavior-openapi.yaml` has no `/self-letter` path, so
 * there are no generated `@xavior/contracts` types for this route (same
 * precedent as endpoints/email-module.ts).
 */
import { http } from '@/lib/http'

export interface SelfLetterResult {
  ok?: boolean
  parentPagesId?: string
  pageId?: string
  error?: string
}

/**
 * `POST /self-letter/generate` — generate (or trigger generation of) the
 * onboarding self-letter. Idempotent on `entryPoint: 'onboarding'`.
 */
export async function generateSelfLetter(
  authToken: string | null,
  body: { entryPoint: string },
): Promise<SelfLetterResult> {
  const res = await http.post<SelfLetterResult>('/self-letter/generate', body, { authToken })
  return res.data
}

export const selfLetter = { generateSelfLetter }
